import ExternalViews from './external-views'

export default ExternalViews
